import { useMutation, useQueryClient } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, queryKeys, ReorderMetricCollectionDto, useAccessToken } from "src/http";

type Variables = {
  metricCollectionGuid: string;
  metricSortOrders: {
    metricGuid: string;
    sortOrder: string;
  }[];
};

const useReorderMetricCollectionRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function reorderMetricCollectionRequest(variables: Variables): Promise<void> {
    const accessToken = await getAccessToken();
    const body: ReorderMetricCollectionDto = {
      metricSortOrders: variables.metricSortOrders,
    };

    const response = await fetch(
      `${configuration.apiRootUrl}/metric-collections/${variables.metricCollectionGuid}/reorder`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        method: "put",
        body: JSON.stringify(body),
      }
    );

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return { reorderMetricCollectionRequest };
};

const useReorderMetricCollection = () => {
  const { reorderMetricCollectionRequest } = useReorderMetricCollectionRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: reorderMetricCollectionRequest,
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries(queryKeys.metrics.getMetricCollection(variables.metricCollectionGuid));
    },
  });
};

export { useReorderMetricCollection };
